import { GetInitialIdListArgument } from 'components/SearchSideBar/types';

/**
 * id配列を取得
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @returns {string[]} id配列
 */
export const getInitialIdList = ({
  savedSearchCondition,
  featuredSearchCondition,
  queries,
}: GetInitialIdListArgument) => {
  // 保存した検索条件
  if (savedSearchCondition) return savedSearchCondition.employNumList ?? [];

  // 特集枠検索条件
  if (featuredSearchCondition) return featuredSearchCondition.employNum ?? [];

  // クエリから取得した検索条件
  return queries ?? [];
};
